// impossible to use anything else than any here
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const updateFragment = (cache: any, data: any, options: any) => {
  const cachedData = cache.readFragment(options);
  cache.writeFragment({
    ...options,
    data: {...cachedData, ...data},
  });
};

export default updateFragment;